<template>
  <section v-if="seoText" class="seo-text">
    <div class="seo-text__box" :class="{ 'is-open': isOpen }">
      <DefContent ref="content" class="seo-text__content" v-html="seoText" />
    </div>

    <span v-if="canToggle" class="seo-text-more" @click="isOpen = !isOpen">
      {{ !isOpen ? messages.readMore : messages.rollUp }}
      <svg class="seo-text-more__icon" :class="{ 'seo-text-more__icon_active': isOpen }">
        <use xlink:href="#svg-arrow-down"></use>
      </svg>
    </span>
  </section>
</template>

<script lang="ts" setup>
import DefContent from '@components/Def/DefContent/DefContent.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { storeToRefs } from 'pinia';

const isOpen = ref(false);
const canToggle = ref(false);
const content = ref<any>(null);

const { seoText, messages } = storeToRefs(useResultsStore());

// без resize listener: 1 вимір після рендера, і все
const checkOverflow = async () => {
  await nextTick();
  const el: HTMLElement | undefined = content.value?.$el;
  if (!el) return;

  // перевіряємо, чи контент реально більший за “згорнутий” блок
  // (буде 1 layout read один раз після mount, це ок)
  const box = el.closest('.seo-text__box') as HTMLElement | null;
  if (!box) return;

  const wasOpen = box.classList.contains('is-open');
  if (wasOpen) box.classList.remove('is-open'); // примусово в “collapsed” для перевірки

  // scrollHeight > clientHeight => є що розгортати
  canToggle.value = box.scrollHeight > box.clientHeight + 2;

  if (wasOpen) box.classList.add('is-open');
};

onMounted(() => {
  if (seoText.value) checkOverflow();
});

// якщо seoText може змінюватись реактивно — виклич checkOverflow() у watcher
</script>

<style lang="scss" scoped>
.seo-text {
  @include block-mb;
}

/* контейнер що “згортає/розгортає” */
.seo-text__box {
  /* Згорнутий стан: жорстко 140px */
  max-height: 130px;
  overflow: hidden;
  position: relative;
}

/* Розгорнутий стан */
.seo-text__box.is-open {
  max-height: none;
  overflow: visible;
}

.seo-text__content {
  font-size: 14px;
  line-height: 150%;
  @include point-md {
    font-size: 16px;
  }
}

.seo-text-more {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: 0.2s linear color;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  color: var(--color-golden-browm);
  margin-top: 16px;
  @include point-md {
    font-size: 16px;
  }
  @include point-lg {
    margin-top: 24px;
  }

  &__icon {
    width: 18px;
    height: 18px;
    margin-left: 4px;
    fill: currentColor;
    transition: 0.2s linear transform;

    &_active {
      transform: rotate(180deg);
    }
  }
}
</style>
